module.exports = __webpack_public_path__ + "img/egp-logo.b833d9e2.svg";